import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import {
  getDatabase,
  ref,
  set,
  get,
  push,
  child,
  onValue,
  update,
  remove,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC3zSoLUaTech4efVhUqEP7VVvSYtnJj9s",
  authDomain: "aerovolt-db464.firebaseapp.com",
  databaseURL: "https://aerovolt-db464-default-rtdb.firebaseio.com",
  projectId: "aerovolt-db464",
  storageBucket: "aerovolt-db464.firebasestorage.app",
  messagingSenderId: "970636161284",
  appId: "1:970636161284:web:a6055cefb52561cf3ce051",
  measurementId: "G-RL9767BD37",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// authentication support for uid generation
const auth = getAuth(app);

const analyticsPromise = typeof window !== "undefined"
  ? isSupported().then((ok) => (ok ? getAnalytics(app) : null))
  : Promise.resolve(null);

export {
  app,
  auth,
  database,
  analyticsPromise,
  ref,
  set,
  get,
  push,
  child,
  onValue,
  update,
  remove,
  query,
  orderByChild,
  equalTo,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
};
